module.exports = __webpack_public_path__ + "static/media/bg_CCL.3e583dfa.jpg";